export default __webpack_public_path__ + "static/media/amex.0e1201dd.svg";